var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',_vm._b({staticClass:"el-button",class:[
    _vm.type ? 'el-button--' + _vm.type : '',
    _vm.size ? 'el-button--' + _vm.size : '' ]},'router-link',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }